




































































































































import Feedback from '@/components/Feedback.vue'
import MenuLevel3 from '@/components/MenuLevel3.vue'
import PadMenu from '@/components/PadMenu.vue'
import PCMenu from '@/components/PCMenu.vue'
import {
  LoginController,
  MemberController,
  MessageController,
  SchoolController,
} from '@/services/request.service'
import {
  getLocale,
  getRoleType,
  getSchoolInfo,
  removeRoleType,
  removeSchoolInfo,
  removeSectionTeacher,
  removeToken,
  removeUserInfo,
  setLocale,
  setRoleType,
  setSchoolInfo,
  setSectionTeacher,
  setUserInfo,
} from '@/utils/utils'
import { ssoUtils } from 'sso-utils'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { RouteRecord } from 'vue-router'
const Logo = require('@/assets/images/logo.svg')

@Component({
  components: {
    PCMenu,
    PadMenu,
    MenuLevel3,
    Feedback,
  },
})
export default class Main extends Vue {
  public schoolVisible = false
  public schoolList: Array<any> = []
  public selectedSchool: any = {
    schoolId: 0,
    name: '',
  }
  public haveSystemMessage = false
  public feedbackVisible = false
  public routeAlive = true
  public fold = false

  @Watch('$route', { immediate: true })
  public onRouteChanged() {
    this.getSystemMessage()
    const schoolInfo = getSchoolInfo()
    if (schoolInfo) {
      this.selectedSchool = schoolInfo
    } else {
      this.logout()
    }
  }

  public get roleType(): string {
    return getRoleType()
  }

  public get loginSource(): string {
    return ssoUtils.getLoginSource()
  }

  public get homeSchoolName(): string {
    if (this.$route.query.schoolId === 'all') {
      return 'all'
    } else {
      if (
        this.schoolList.filter(school => school.key.toString() === this.$route.query.schoolId)
          .length
      ) {
        return this.schoolList.filter(
          school => school.key.toString() === this.$route.query.schoolId
        )[0].value
      } else {
        return 'all'
      }
    }
  }

  public get contentHeaderShow(): boolean {
    return !this.$route.meta.rootPage
  }

  public get routes(): Array<any> {
    const router = this.$route as any
    return router.matched.filter((item: RouteRecord) => item.meta && item.meta.routerName)
  }

  public get isPad(): boolean {
    return document.body.clientWidth < 1280
    // return navigator.userAgent.indexOf('iPad') !== -1
  }

  public get logo(): any {
    return this.$store.state.logo || Logo
  }

  public redirectPortal = ssoUtils.redirectPortal

  public backToPortal(): void {
    removeToken()
    this.redirectPortal()
  }

  public created(): void {
    this.getUserInfo()
    this.getSchoolList()
    const locale = getLocale()
    this.$store.commit('changeLocale', locale)
  }

  public getUserInfo(): void {
    MemberController.queryUserInfo()
      .then(res => {
        this.$store.commit('setUserInfo', {
          username: res.data.enName + ' ' + res.data.name,
          memberId: res.data.memberId,
          avatar: res.data.avatarUrl,
        })
        setUserInfo(
          JSON.stringify({
            username: res.data.enName + ' ' + res.data.name,
            memberId: res.data.memberId,
            avatar: res.data.avatarUrl,
          })
        )
        this.$store.commit('setRoleType', res.data.roleType)
        setRoleType(res.data.roleType)
        this.$store.commit('setSectionTeacher', res.data.sectionTeacher)
        setSectionTeacher(res.data.sectionTeacher)
      })
      .catch(err => {
        console.error(err)
      })
  }

  public getSchoolList(): void {
    this.selectedSchool = getSchoolInfo()
    SchoolController.querySchoolBriefList()
      .then(res => {
        this.schoolList = res.data
        this.selectedSchool = res.data.filter(
          school => school.schoolId === this.selectedSchool.schoolId
        )[0]
      })
      .catch(err => {
        console.error(err)
      })
  }

  public getSystemMessage(): void {
    MessageController.hasUnReadSystem().then(res => {
      this.haveSystemMessage = res.data
    })
  }

  public viewSystemMessage(): void {
    this.$router.push({ name: 'systemMessage' }).catch(err => {})
  }

  public openPersonal(): void {
    this.$router.push({ name: 'personal' }).catch(err => {})
  }

  public changeLocale(): void {
    const currentLocale = this.$i18n.locale
    if (currentLocale === 'zh') {
      this.$i18n.locale = 'en'
      this.$store.commit('changeLocale', 'en')
      setLocale('en')
    } else if (currentLocale === 'en') {
      this.$i18n.locale = 'zh'
      this.$store.commit('changeLocale', 'zh')
      setLocale('zh')
    }
    this.routeAlive = false
    this.$nextTick(() => {
      this.routeAlive = true
    })
  }

  public selectSchool({ key }): void {
    const schoolList = this.schoolList
    const selectedSchool = schoolList.filter(school => school.schoolId === key)[0]
    this.selectedSchool = selectedSchool
    setSchoolInfo(selectedSchool)
    location.reload()
  }

  public feedback(): void {
    this.feedbackVisible = true
  }

  public logout(): void {
    LoginController.logout()
      .then(res => {
        removeToken()
        removeSchoolInfo()
        removeRoleType()
        removeSectionTeacher()
        removeUserInfo()
        this.$store.commit('changeForceBack', true)
        this.$store.dispatch('refreshRoutes')
        this.$router.push({ name: 'login' }).catch(err => {})
      })
      .catch(err => {
        console.error(err)
      })
  }
}
